import { useQuery } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";
import PremierPlusTapestripDTO from "src/models/PremierPlusTapestripDTO";
import { queryOptions } from "./v4QueryOptions/queryOptions";
import { binDBKeys } from "src/pages/binOverview/BinCommander";
import { TAPESTRIP_CATEGORY } from "./getCycleAveragesPremierPlusOptions";
import { QueryTypes } from "./shared";

export const premierPlusBinTapestripDataQueryOptions = (params: {
    binId: number,
    from: string | null,
    to: string | null,
}) => {
    return queryOptions({
            queryKey: [...binDBKeys.bin(params.binId!), {category: TAPESTRIP_CATEGORY, purpose: "TapestripHistory", from: params.from, to: params.to}] as const,
            queryFn: async (q) => {
                return await BinApiService.getPremierPlusBinTapestrips(params.binId, params.from, params.to, q.signal);
        },
    })
}

export const useGetPremierPlusBinTapestripData = (binId: number, from: string | null, to: string | null, options: QueryTypes = {}) => {
    const _queryOptions = premierPlusBinTapestripDataQueryOptions({
            binId: binId,
            from: from,
            to: to,
    })
    const getPremierPlusTapestripDataQuery = useQuery<PremierPlusTapestripDTO[]>({
        ..._queryOptions,
        enabled: options.enabled,
        refetchOnWindowFocus: options.refetchOnWindowFocus,
        retry: options.retry,
    });

    return { queryKey: _queryOptions.queryKey, getPremierPlusTapestripDataQuery };

}